module.exports = __webpack_public_path__ + "img/fcmd2.b2df5447.jpg";